import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../ReusableComponents/Axios";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const DiffGraph = (props) => {
  const chartRefs = useRef({});
  const [graphData, setGraphData] = useState({});
  const [GraphImages, SetGraphImages] = useState();

  const colors = ["#9fbfcc", "#e5a900", "#ff2b2b"];

  const GetAllSubjectsData = async () => {
     props.GraphImg("");
    try {
      const requests = props.Subjects?.map((subject) =>
        axiosInstance.get(
          `/InstitutionAdmin/GetDLWisePerformanceByInstitute?ContestcreationId=${props.CCAT?.contestCreationId}&SubjectName=${subject}&AssessmentType=${props.CCAT?.assessmentType}&InstituteId=${props.SIND}&Grade=${props.Grade}`
        )
      );

      const responses = await Promise.all(requests);

      let finalData = {};

      responses.forEach((res, index) => {
        finalData[props.Subjects[index]] = res.data.map((item) => ({
          label: `${item.level} - (${item.questionIds} Questions)`,
          value: item.percentage,
        }));
      });

      setGraphData(finalData);
      setTimeout(() => {
        getChartImage();
      }, 1500);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (props.Subjects?.length > 0) {
      GetAllSubjectsData();
    }
  }, [props.CCAT, props.SelectINID, props.Grade, props.Subjects]);
  const getChartImage = (subject) => {
    const images = {};

    props.Subjects.forEach((subject) => {
      const chart = chartRefs.current[subject];

      if (chart) {
        images[subject] = chart.canvas.toDataURL("image/png");
      }
    });
    SetGraphImages(images);
    props.GraphImg(images);
  };
  const getChartData = (subject) => ({
    labels: graphData[subject]?.map((item) => item.label) || [],
    datasets: [
      {
        label: "Performance %",
        data: graphData[subject]?.map((item) => item.value) || [],
        backgroundColor: colors,
        borderRadius: 5,
        barThickness: 80,
      },
    ],
  });

  const options = {
    // aspectRatio: 3,
    responsive: true,
    // maintainAspectRatio: false,

    plugins: {
      legend: {
        display: false,
        labels: {
          font: {
            size: 24, // 👈 increase legend font size
          },
        },
      },

      // tooltip: {
      //   callbacks: {
      //     label: function (context) {
      //       return `${context.parsed.y}%`;
      //     },
      //   },
      // },

      datalabels: {
        anchor: "end",
        align: "end",
        formatter: (value) => value + "%",
        //  color: () => "#FFFFFF",
        font: {
          weight: "bold",
          size: 24,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Difficulty Level",
          font: {
            size: 34,
          },
        },

        grid: {
          display: false,
        },
        ticks: {
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.split("-");
          },
          font: {
            size: 30,
          },
        }
      },

      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          font: {
            size: 30,
          },
        },
        title: {
          display: true,
          text: "Average % Achievement",
          font: {
            size: 34,
          },
        },
      },
    },
  };

  return (
    <>
      {props.Subjects?.map((subject) => (
        <div
          key={subject}

        >
          <Bar ref={(el) => (chartRefs.current[subject] = el)} style={{
            display: "none",
            // marginBottom: "10px",
            // width: "100%",
            // height: "50px",
          }}
            data={getChartData(subject)}
            options={options} plugins={[ChartDataLabels]}
          />
        </div>
      ))}
    </>
  );
};

export default DiffGraph;